// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202608132004/js/" + chunkId + "." + {"44":"07474be1","225":"63501f76","481":"1424ef9f","486":"2e4d178b","770":"fb85c437"}[chunkId] + ".0.32296611281224086.chunk.js";
};